import { Download, Trash, View } from "@/assets/icons";
import { IconButton } from "@/components";
import styles from "@/pages/requests/components/attachments/styles.scss";
import { FileDataProps } from "@/services/api";
import { formatFileSize, getFileIcon, getNormalizedFileName } from "@/utils";
import { FC } from "react";

interface AttachmentRowProps {
  file?: FileDataProps;
  onDownloadDocument: (file: FileDataProps) => void;
  onRemoveAttachment: () => void;
  onPreviewDocument: (file: FileDataProps) => void;
  removeDisabled: boolean;
}

export const AttachmentRow: FC<AttachmentRowProps> = ({
  file,
  onDownloadDocument,
  onRemoveAttachment,
  onPreviewDocument,
  removeDisabled = false,
}) => {
  if (!file) {
    return null;
  }

  const fileIcon = getFileIcon(
    typeof file.type === "string" && file.type.includes("/")
      ? file.type.split("/")[1]
      : "pdf",
  );

  return (
    <div className={styles.attachment}>
      <div className={styles.attachmentFileIcon}>{fileIcon}</div>
      <div className={styles.attachmentFileProps}>
        <span>{getNormalizedFileName(file.name ?? "")}</span>
        <span>{formatFileSize(file.size ?? 0)}</span>
      </div>
      <div className={styles.actionBtnGroup}>
        <IconButton
          icon={View}
          className={styles.iconContainer}
          onClick={() => {
            onPreviewDocument(file);
          }}
        />
        <IconButton
          icon={Download}
          className={styles.iconContainer}
          onClick={() => {
            onDownloadDocument(file);
          }}
        />

        {!removeDisabled && (
          <IconButton
            icon={Trash}
            className={styles.iconContainer}
            onClick={onRemoveAttachment}
          />
        )}
      </div>
    </div>
  );
};
